import { Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import InboxChip from './InboxChip.jsx';
import OverflowTagsTooltip from './OverflowTagsTooltip.jsx';

const STUDIO_LABEL_KEYS = {
  'governance-operations': 'studio.governanceOperations',
  'agentic-oversight': 'studio.agenticOversight',
};

/**
 * Short category code (GOV / AGNT / CLIENT) as the prototype renders it. The
 * full studio name would eat the row, so it moves behind a tooltip; the +N
 * still covers additional studios.
 */
function CategoryChip({ category, studio, extraCount = 0, extraItems = [] }) {
  const { t } = useTranslation('work-queues-app');
  const labelKey = STUDIO_LABEL_KEYS[studio];
  const studioLabel = labelKey ? t(labelKey) : studio;
  const overflowItems = extraItems.length
    ? extraItems
    : Array.from({ length: extraCount }, () => t('studio.additionalStudio'));

  if (!category && !studio) return null;

  return (
    <span className="inline-flex items-center gap-1">
      {studioLabel ? (
        <Tooltip size="compact" content={studioLabel} position="top" align="start" arrow={false}>
          <InboxChip>{category ?? studioLabel}</InboxChip>
        </Tooltip>
      ) : (
        <InboxChip>{category}</InboxChip>
      )}
      <OverflowTagsTooltip items={overflowItems} />
    </span>
  );
}

export default CategoryChip;
